<!--
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2026-01-09 15:36:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-22 15:15:43
-->
<template>
    <div class="subaccount-history sm-qu-padding">
        <CCard color="light">
            <!-- <CCardHeader>
                <div class="ch-header">
                    <div>
                        <el-button
                        @click="openCreateSubAccountDialog"
                        class="create-holder-btn"
                        >{{ $t("SubAccount.CreateSubAccount") }}</el-button
                        >
                    </div>
                </div>
            </CCardHeader> -->
            <CCardBody>
                <el-table :data="items" style="width: 100%">
                <template slot="empty">
                    <div style="margin: 3rem 0">
                    <h2>
                        No items
                        <CIcon
                        name="cilBan"
                        style="color: #e53535; width: 30px; height: 30px"
                        />
                    </h2>
                    </div>
                </template>
                <el-table-column
                    align="center"
                    prop="email"
                    width="320px"
                    :label="$t('SubAccount.HistoryListEmail')"
                >
                <template slot-scope="scope">
                    <div class="subaccount-columnText-bold">{{ scope.row.email }}</div>
                </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="reg_url"
                    :label="$t('SubAccount.HistoryListRegUrl')"
                >
                    <template slot-scope="scope">
                        <div style="display:flex;align-items:center;gap:5px;justify-content:center;">
                            <el-tooltip
                                v-if="isOverflow"
                                :content="scope.row.reg_url"
                                placement="top"
                                >
                                <div ref="textRegUrlRef" class="ellipsis-1 subaccount-columnText-bold">
                                    <a target="_blank" :href="scope.row.reg_url" style="color:#1675d4">{{ scope.row.reg_url }}</a>
                                </div>
                            </el-tooltip>
                            <div ref="textRegUrlRef" class="ellipsis-1 subaccount-columnText-bold" v-else>
                                <a target="_blank" :href="scope.row.reg_url" style="color:#1675d4">{{ scope.row.reg_url }}</a>
                            </div>
                            <i style="color: rgb(0,190,164);cursor:pointer;" @click="getCopy(scope.row.reg_url)" class="el-icon-document-copy"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="tag"
                    :label="$t('SubAccount.HistoryListTag')"
                >
                <template slot-scope="scope">
                    <div class="subaccount-columnText-bold">{{ scope.row.tag }}</div>
                </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="status"
                    :label="$t('SubAccount.HistoryListStatus')"
                >
                    <template slot-scope="scope">
                    <div style="display:flex;align-items:center;gap:5px;">
                        <el-tag
                        size="small"
                        effect="dark"
                        :type="customStatusType(scope.row)"
                        >{{ scope.row.status }}</el-tag
                        >
                        <el-button @click="confirmUpdateStatus(scope.row, 0)" size="small" v-if="scope.row.status === 'Pending'" type="text" style="outline:0;color:red;font-weight:bold;">
                            <a style="color:#1675d4" href="javascript:;">{{$t('SubAccount.HistoryPendingStatusBtn')}}</a>
                        </el-button>
                        <el-button @click="confirmUpdateStatus(scope.row, 1)" size="small" v-if="scope.row.status === 'Cancelled'" type="text" style="outline:0;color:#67C23A;font-weight:bold;">
                            <a style="color:#1675d4" href="javascript:;">{{$t('SubAccount.HistoryCancelledStatusBtn')}}</a>
                        </el-button>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="create_time"
                    :label="$t('SubAccount.HistoryListCreateTime')"
                >
                    <template slot-scope="scope">
                        <div style="display:flex;justify-content:center;align-items:center;">
                            <div class="subaccount-columnText-bold" style="width:88px;text-align:center">{{ scope.row.create_time }}</div>
                        </div>
                    </template>
                </el-table-column>
                
                </el-table>
            </CCardBody>
            <!-- <CCardFooter>
                <el-pagination
                background
                layout="prev, pager, next"
                :total="page_total"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="page_size"
                @current-change="handerPage"
                >
                </el-pagination>
            </CCardFooter> -->
        </CCard>
    </div>
</template>

<script>
import { getSubAccountHistoryList, updateSubAccountHistoryStatus } from "../../api/http"
export default {
    data() {
        return {
            items: [
                // {
                //     email: '2250247655@qq.com', // 账户邮箱
                //     reg_url: 'https://test.fotoncard.com?primary_uid=9323&auth=Hkle838hfjskfhsk8883hKJH7dKJG', // 开户地址
                //     tag: 'Test',
                //     status: 'Complete',
                //     create_time: '2025-01-08 12:10:00',
                //     id: 1
                // },
                // {
                //     email: 'guueas@qq.com', // 账户邮箱
                //     reg_url: 'https://test.fotoncard.com?primary_uid=9323&auth=Hkle838hfjskfhsk8883hKJH7dKJG', // 开户地址
                //     tag: 'Test',
                //     status: 'Pending',
                //     create_time: '2025-01-08 12:10:00',
                //     id: 2
                // },
                // {
                //     email: 'hhtest@qq.com', // 账户邮箱
                //     reg_url: 'https://test.fotoncard.com?primary_uid=9323&auth=Hkle838hfjskfhsk8883hKJH7dKJG', // 开户地址
                //     tag: 'Test',
                //     status: 'Cancelled',
                //     create_time: '2025-01-08 12:10:00',
                //     id: 3
                // },
            ],
            page_total: 0,
            page_size: 20,
            page: 1,
            isOverflow: false
        }
    },
    created() {
        this.initSubAccountHistoryList()
    },
    mounted() {
        this.$nextTick(this.checkOverflow)
    },
    methods: {
        // 获取子账户数据
        initSubAccountHistoryList() {
            const data = {
                type: "get_create_subaccount_history",
                uid: window.localStorage.getItem("uid"),
                // page: this.page,
                // page_size: this.page_size,
            };
            getSubAccountHistoryList(data).then((res) => {
                if (res.code == 200) {
                    this.items = res.data;
                    // this.page_total = Number(res.data.size) || 20;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 更新开户子账户开户记录状态
        updateSubAccountHistoryListStatus(row, active) {
            // updateSubAccountHistoryStatus
            const data = {
                type: "update_pending_subaccount_status",
                uid: window.localStorage.getItem("uid"),
                id: row.id,
                active: active
            };
            updateSubAccountHistoryStatus(data).then((res) => {
                if (res.code == 200) {
                    // 重新请求列表数据
                    this.initSubAccountHistoryList();
                    this.$message.success(res.message);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 状态中的 取消、开启 active为0取消、为1开启
        confirmUpdateStatus(row, active) {
            const tipMessage = active === 0 ? this.$t('SubAccount.HistoryPendingStatusBtnTip') : this.$t('SubAccount.HistoryCancelledStatusBtnTip')
            this.$confirm(tipMessage, "", {
                confirmButtonText: this.$t('SubAccount.Submit'),
                closeOnClickModal: false,
                showCancelButton: false,
                showClose: true,
                type: "warning"
            }).then(() => {
                this.updateSubAccountHistoryListStatus(row, active)
            })
        },
        // 切换页码
        handerPage(e) {
            this.page = e
            this.initSubAccountHistoryList()
        },
        // 状态颜色
        customStatusType(row) {
            if (row.status === "Complete") {
                return "success";
            } else if(row.status === "Pending") {
                return "warning";
            } else if(row.status === "Frozen") {
                return "danger";
            } else if(row.status === "Declined") {
                return "danger";
            } else {
                return "info";
            }
        },
        // copy
        getCopy(data) {
            let input = document.createElement("input"); // js创建一个input输入框
            input.value = data; // 将需要复制的文本赋值到创建的input输入框中
            document.body.appendChild(input); // 将输入框暂时创建到实例里面
            input.select(); // 选中输入框中的内容
            document.execCommand("Copy"); // 执行复制操作
            document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
            this.$message({
                type: "success",
                message: "Copied",
            });
        },
        // 单行文本显示
        checkOverflow() {
            const el = this.$refs.textRegUrlRef
            if (!el) return

            // scrollWidth > clientWidth 表示溢出
            this.isOverflow = el.scrollWidth > el.clientWidth
        },
    }
}
</script>

<style scoped>
.subaccount-history {
    padding-left: 2.5rem;
    overflow: hidden;
}
.ellipsis-1 {
  max-width: 220px;        /* 必须指定宽度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.subaccount-columnText-bold {
  font-weight: bold;
  font-size: 16px;
}
</style>